import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Country, HProductDTO, PagedModelHProductDTO, PartnerDto } from '../../api/models';
import { SessionService } from '../../common/session.service';
import { HProductControllerService } from '../../api/services';
import * as bootstrap from 'bootstrap';
import { constants } from '../../common/constants';
import { Router } from '@angular/router';


@Component({
    selector: 'app-hproduct',
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    templateUrl: './hproduct.component.html',
    styleUrl: './hproduct.component.css'
})
export class HproductComponent implements OnInit {

   

    
    productForm: FormGroup;
    submitted = false;
    preview: any = null;
    promoterId: number=0;
    promoters?: PartnerDto[];
    currentProduct?: HProductDTO  ;
    products?: PagedModelHProductDTO;
    message= '';
    messageType: 'text-success' | 'text-danger' = 'text-success';
    countries:Array<Country>=constants.MANAGED_COUNTRIES;

    constructor(private formBuilder: FormBuilder,
        private router:Router,
        private sess: SessionService,
        private productService: HProductControllerService) {
        this.productForm = this.formBuilder.group({
            id: [''],
            name: ['', [Validators.required]],
            specifications: [''],
            type: ['', Validators.required],
            zone: ['', [Validators.required ]],
            superficie: ['', [Validators.required]],
            price: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
            promoterId: ['', [Validators.required]],
            periodicAmount: [0, [Validators.required, Validators.min(0)]],
            insuranceAmount: [0, [Validators.min(0)]],
            openingFees: [0, [Validators.min(0)]],
            country:['', Validators.required],
            durationYears:['',[Validators.required,Validators.min(1)]]
        });
       
    }

    ngOnInit(): void {
      const sess = this.sess.getSessionInfo();
        if(sess.partner?.type=='MERCHANT'){
      this.promoterId =sess.partner?.id!!;
       this.productForm.patchValue({
            promoterId: this.promoterId
        });
    }
  
    }
   

    submitProduct(): void {
        this.submitted = true;
        if (this.productForm.invalid) {
            return;
        }

        const newProduct: HProductDTO = {
            name: this.productForm.value.name,
            type: this.productForm.value.type,
            zone: this.productForm.value.zone,
            price: this.productForm.value.price,
            durationYears:this.productForm.value.durationYears,
            insuranceAmount:this.productForm.value.insuranceAmount,
            openingFees:this.productForm.value.openingFees,
            country:{
                isoCode2:this.productForm.value.country,
            },
            specifications: this.productForm.value.specifications,
            superficie: this.productForm.value.superficie,
            promoter: {
                id: this.productForm.value.promoterId,
                name: '',
                address: '',
                phone: ''
            }
            };
        this.preview = newProduct;
        this.currentProduct = newProduct;
        console.log('Produit soumis :', newProduct);
        
    }

    resetForm(): void {
        this.productForm.reset({});
        this.submitted = false;
        this.currentProduct = undefined;
        this.preview = null;
        if(this.promoterId){
            this.productForm.patchValue({
                promoterId: this.promoterId
            });
        }
    }


    goTList(): void {
        this.router.navigateByUrl('housing/products');
    }

    addOrEditProduct(): void {
        if(this.currentProduct?.id) {
             this.updateProduct(this.currentProduct);
        } else {
           this.addProduct(this.currentProduct);
        }
    }
    updateProduct(product: any): void {

    }

    

    displaayForm(): void {
    
          this.preview = null;
          this.currentProduct = undefined;
          this.submitted = false;
        }

    addProduct(product: any): void {
        
        this.productService.addProduct(  product ).subscribe({
            next: (response:HProductDTO) => {
                console.log('Produit ajouté avec succès', response);
                 this.preview = null;
                 this.currentProduct = undefined;
                 this.submitted = false;
                 this.resetForm();
                 this.messageType = 'text-success';
                 this.message = 'Produit ' + response.name + ' ajouté avec succès';

                 const modAdd = new bootstrap.Modal('#modalProduct',{});
                             modAdd.show();

            },
            error: (error:HttpErrorResponse) => {
                this.messageType = 'text-danger';
                this.message = error.error?.message || 'Erreur lors de l\'ajout du produit';
                 const modAdd = new bootstrap.Modal('#modalProduct',{});
                             modAdd.show();
                console.error('Erreur lors de l\'ajout du produit', error);
            }
        });
        
    }

    get f() {
        return this.productForm.controls;
    }


   
    
}
